import { DODA_SITE_URL } from '@doda/common/src/constants/urls';
import { EXTEND_CONDITION_QUERY } from 'components/SearchSideBar/constants';

export const JOB_SEARCH_LIST_NO_RESULT_HREF = `${DODA_SITE_URL.jobSearchTop}?${EXTEND_CONDITION_QUERY.JOB_SEARCH_LIST}`;
